import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {HotelsListWrapper} from './hotel-list/HotelsList'
import {useIntl} from 'react-intl'
import {AzPageHeader} from '../../components/AzPageHeader'

const HotelPage = () => {
  const intl = useIntl()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='hotels'
          element={
            <>
              <AzPageHeader
                title={intl.formatMessage({id: 'HOTEL_PAGE.TITLE'})}
                subtitle={intl.formatMessage({id: 'HOTEL_PAGE.BREADCRUMB'})}
              />
              <HotelsListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/hotel-management/hotels' />} />
    </Routes>
  )
}

export default HotelPage;